import { RequestCommentTypeEnum } from '@omnea-app/packages/universal/hasura/graphql'
import { useInsertRequestComment } from './useInsertRequestComment'
import { useRefetchForms } from './useRefetchForms'
import type { UploadedFile } from '../uploadedFile'

export type AmendmentRequestInput = {
  message: string
  files?: UploadedFile[]
  questionTitle?: string
}

export const useRequestAmendment = ({ requestId, onError }: { requestId: string; onError?: () => void }) => {
  const { mutateAsync: insertRequestComment, isPending } = useInsertRequestComment({ requestId, onError })
  const refetchForms = useRefetchForms()

  const requestAmendment = async (
    {
      requestFormId,
      questionId,
      requestStepId,
      taskId,
    }: { requestFormId: string; questionId: string; requestStepId?: string; taskId?: string },
    amendmentRequestInput: AmendmentRequestInput
  ) => {
    const created = await insertRequestComment({
      requestId,
      requestFormId,
      questionId,
      requestStepId,
      taskId,
      payload: {
        text: amendmentRequestInput.message,
        questionTitle: amendmentRequestInput.questionTitle,
        files: amendmentRequestInput.files || [],
      },
      type: RequestCommentTypeEnum.AMENDMENT_REQUEST,
    })
    const commentId = created?.id
    if (!commentId) {
      throw new Error('Expected comment id from create request comment')
    }
    await refetchForms({
      requestId,
      requestFormId,
    })
    return { commentId }
  }

  return { requestAmendment, isPending }
}
